import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=6f932b57&"
import script from "./UserLayout.vue?vue&type=script&lang=js&"
export * from "./UserLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports